"use client";
import {Select, SelectContent, SelectItem, SelectTrigger, SelectValue} from "@/components/ui/select";
import {Input} from "@/components/ui/input";
import {formatPrice} from "@/utils/format-price";
import {Mail, MessageCircle, Phone} from "lucide-react";
import {Button} from "@/components/ui/button";
import React, {useEffect, useState} from "react";
import FormLead from "@/components/FormLead";
import {addVehicleToCart, clearCart} from "@/redux/cartSlice";
import {useRouter} from "next/navigation";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "@/redux/store";
import {addMonths, format} from "date-fns";
import {Skeleton} from "@/components/ui/skeleton";
import {CONTACT_PHONE_HREF} from "@/lib/public-config";
import ChatH24Badge from "@/components/ChatH24Badge";


interface ConfiguratoreProps {
    veicoloData: any
    tipoUtenteListino: string
    onChangeDurata: (value: any) => void;
    onChangeKm: (value: any) => void;
    onChangeAnticipo: (value: any) => void;
    onChangeCauzione?: (value: any) => void;
    onScrollToFromNoleggio?: () => void;
}

export default function Configuratore({veicoloData, tipoUtenteListino ,onChangeDurata,onChangeKm,onChangeAnticipo,onChangeCauzione, onScrollToFromNoleggio}: ConfiguratoreProps) {
    const dispatch = useDispatch();
    const vehiclesInCart = useSelector((state: RootState) => state.cart.vehicles);
    const [km, setKm] = useState('20000');
    const [durata, setDurata] = useState('24');
    const [anticipo, setAnticipo] = useState('3000');
    const [cauzione, setCauzione] = useState('0');
    const [monthlyRate, setMonthlyRate] = useState('');  // Default or initial monthly rate
    const [ammortamento, setAmmortamento] = useState('');  // Default or initial ammortamento
    const [maxAnticipo, setMaxAnticipo] = useState(0);
    const [count, setCount] = useState(0);
    const [error, setError] = useState('');
    const [isModalOpen, setModalOpen] = useState(false);
    const [titleModal, setTitleModal] = useState('Richiedi un preventivo');
    const router = useRouter();
    const [loading, setLoading] = useState(false);

    const handleKmChange = (newValue: any) => {
        setKm(newValue);
        onChangeKm && onChangeKm(newValue);
    };

    const handleDurataChange = (newValue: any) => {
        setDurata(newValue);
        onChangeDurata && onChangeDurata(newValue);
    };

    const handleCauzioneChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        if (value === '') {
            setCauzione('');
        } else {
            const parsedValue = parseFloat(value);
            if (!isNaN(parsedValue)) {
                setCauzione(value);
                onChangeCauzione && onChangeCauzione(value);
                setError('');
            }
        }
    };

    const handleAnticipoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        if (value === '') {
            setAnticipo('');
        } else {
            const parsedValue = parseFloat(value);
            if (!isNaN(parsedValue) && parsedValue <= maxAnticipo) {
                setAnticipo(value);
                onChangeAnticipo && onChangeAnticipo(value);
                setError('');
            } else {
                setError('Il valore massimo dell\'anticipo è ' + formatPrice(maxAnticipo, true));
            }
        }
    };

    useEffect(() => {
        // Calcolo iniziale al montaggio del componente
        fetchMonthlyRate();
    }, []);

    useEffect(() => {
        if (durata && maxAnticipo) {
            // maxAnticipo = rata mensile * durata - 30%
            let maxAnticipo = parseFloat(monthlyRate) * +durata;
            // maxAnticipo = maxAnticipo - 30%
            maxAnticipo = maxAnticipo / 2
            setMaxAnticipo(maxAnticipo);
            console.log('maxAnticipo:', maxAnticipo);
        }

    }, [durata]);

    const fetchMonthlyRate = async () => {

        setLoading(true)
        let kmSel = km;

        if (km === '40000') {
            kmSel = 'SUPER1';
        }

        const today = new Date();
        const dataInizio = format(today, "yyyy-MM-dd");
        const dataFine = format(addMonths(today, +durata), "yyyy-MM-dd");

        console.log('Cauzione', cauzione)

        const params = {
            comando: 'CALNOL',
            acconto: anticipo,
            cauzione: cauzione,
            articolo : veicoloData.articolo2,
            category: kmSel,
            duration: durata,
            dataInizio,
            dataFine
        };


        try {
            const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/noleggio`, {
                method: "POST",
                body: JSON.stringify(params),
                headers: {
                    "Content-Type": "application/json",
                },
            });

            console.log(response)

            if (!response.ok) {
                setLoading(false)
                throw new Error('Network response was not ok');
            }

            const data = await response.json();
            setMonthlyRate(data.IMPRATA);
            setAmmortamento(data.AMMORTAMENTO[data.AMMORTAMENTO.length - 1].VALORE_RESIDUO);

            if (count < 1) {
                setCount(count + 1);

                let maxAnticipo = parseFloat(data.IMPRATA) * +durata;
                maxAnticipo = maxAnticipo / 2
                setMaxAnticipo(maxAnticipo);
            }

        } catch (error) {
            setLoading(false)
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false)
        }
    };


    const handleAddToCart = () => {
        dispatch(clearCart());
        dispatch(addVehicleToCart({
            ...veicoloData,
            type: 'noleggio',
            kmNoleggio: km,
            durataNoleggio: durata,
            anticipoNoleggio: anticipo,
            rataNoleggio: monthlyRate,
            cauzioneNoleggio: cauzione
        }));

        console.log('vehiclesInCart:', {
            ...veicoloData,
            type: 'noleggio',
            kmNoleggio: km,
            durataNoleggio: durata,
            anticipoNoleggio: anticipo,
            rata: monthlyRate,
            cauzioneNoleggio: cauzione
        });

            router.push('/checkout'); // Reindirizza al checkout

    };

    function scrollToFromNoleggio() {
        onScrollToFromNoleggio && onScrollToFromNoleggio();
    }

    return (
        <>
            {isModalOpen &&
                <FormLead open={isModalOpen} title={titleModal} marca={veicoloData.marca} modello={veicoloData.modello}
                          articolo={veicoloData.articolo2} setOpen={setModalOpen} textarea={true} whatsappMessage={`Salve, sono interessato al noleggio del veicolo: ${veicoloData.marca ?? ''} ${veicoloData.modello ?? ''} (${veicoloData.articolo2 ?? ''}). Parametri: ${durata} mesi, ${km} km/anno, anticipo ${anticipo}€. Vorrei avere maggiori informazioni.`}/>}

            <div className="bg-white rounded-md p-3 flex flex-col justify-between">

                <div>
                    <p className="font-bold text-2xl">Scegli i parametri</p>

                    <div className="grid my-3 grid-cols-2 max-sm:grid-cols-1 max-sm:gap-y-3 gap-3 gap-x-3">
                        <div>
                            <label htmlFor="km-select"
                                   className="block text-sm font-medium text-gray-700">KM
                                annui</label>
                            <Select value={km} onValueChange={handleKmChange}>
                                <SelectTrigger>
                                    <SelectValue placeholder="Km annui"/>
                                </SelectTrigger>
                                <SelectContent>
                                    <SelectItem key="1" value="10000">10.000</SelectItem>
                                    <SelectItem key="2" value="15000">15.000</SelectItem>
                                    <SelectItem key="3" value="20000">20.000</SelectItem>
                                    <SelectItem key="4" value="30000">30.000</SelectItem>
                                    <SelectItem key="5" value="40000">40.000</SelectItem>
                                </SelectContent>
                            </Select>
                        </div>
                        <div>
                            <label htmlFor="durata-select"
                                   className="block text-sm font-medium text-gray-700">Durata
                                (mesi)</label>
                            <Select value={durata} onValueChange={handleDurataChange}>
                                <SelectTrigger>
                                    <SelectValue placeholder="Mesi"/>
                                </SelectTrigger>
                                <SelectContent>
                                    <SelectItem key="1" value="12">12</SelectItem>
                                    <SelectItem key="2" value="18">18</SelectItem>
                                    <SelectItem key="3" value="24">24</SelectItem>
                                    <SelectItem key="4" value="30">30</SelectItem>
                                    <SelectItem key="5" value="36">36</SelectItem>
                                    <SelectItem key="6" value="42">42</SelectItem>
                                    <SelectItem key="7" value="48">48</SelectItem>
                                </SelectContent>
                            </Select>
                        </div>
                        <div>
                            <label htmlFor="anticipo-input"
                                   className="block text-sm font-medium text-gray-700">Anticipo</label>
                            <Input type="text" placeholder="Anticipo" value={anticipo}
                                   onChange={handleAnticipoChange} id="anticipo-input"/>
                        </div>
                        <div>
                            <label htmlFor="cauzione-input"
                                   className="block text-base font-bold text-gray-700">Cauzione</label>
                            <Input type="text" placeholder="Cauzione" value={cauzione}
                                   onChange={handleCauzioneChange} id="cauzione-input"/>
                        </div>

                        <div className="col-span-2 max-sm:col-span-1">
                            <Button
                                onClick={fetchMonthlyRate}
                                disabled={loading}
                                className="bg-gradient-custom w-full text-xl font-medium text-white px-5 py-6 rounded-md hover:opacity-90 transition duration-300"
                            >
                                {loading ? "Calcolo..." : "Calcola"}
                            </Button>
                        </div>
                    </div>
                    <p className="text-red-500">{error}</p>
                </div>

                <div className="flex justify-evenly items-center">
                    <div className="flex">
                        <h3 className="gradient-text text-6xl max-sm:text-4xl font-bold flex flex-col">
                            {loading ? (
                                <Skeleton className="h-10 w-32" />
                            ) : (
                                formatPrice(+monthlyRate, true)
                            )}
                            <span className="text-sm font-medium">al mese iva esclusa</span>
                        </h3>
                    </div>
                    <div className="flex flex-col text-xl gap-y-2 ">
                        <p className="text-primary max-sm:text-base"><strong>{km}</strong> km annui
                        </p>
                        <p className="text-primary max-sm:text-base"><strong>{durata} </strong> mesi
                        </p>
                        <p className="text-primary max-sm:text-base">
                            <strong>{formatPrice(+anticipo, true)}</strong> anticipo i.e.</p>
                    </div>

                </div>


                <div className="flex flex-col gap-y-3">

                    <div className="grid grid-cols-2 gap-2 ">

                        <div className="relative col-span-1">
                            <ChatH24Badge />
                            <button onClick={() => {
                                setTitleModal('Chatta con noi');
                                setModalOpen(true);
                            }}
                                    className="flex w-full gap-x-2 items-center justify-center bg-transparent border border-primary text-primary p-3 rounded-md font-bold transition duration-300">
                                <MessageCircle/> Chatta
                            </button>
                        </div>
                        <a href={CONTACT_PHONE_HREF}
                                className="col-span-1 flex gap-x-2 items-center justify-center bg-transparent border border-primary text-primary p-3 rounded-md font-bold  transition duration-300">
                            <Phone/> Chiama
                        </a>

                    </div>

                    <div className=" bg-alert rounded-md">
                        <p className="text-center p-1 text-white">Prelazione sull’acquisto
                            a {formatPrice(+ammortamento, true)} iva esclusa</p>
                    </div>


                    <div className="flex justify-center gap-x-2">
                        <Button
                            onClick={scrollToFromNoleggio}
                            className="bg-gradient-custom w-full text-2xl  font-medium text-white px-5 py-6 rounded-md animate-border-pulse">Scarica
                            il preventivo</Button>

                        {
                            tipoUtenteListino == 'COM' && (
                                <Button variant='outline'
                                        onClick={handleAddToCart}
                                        className=" w-full text-2xl border-primary border-2  font-medium text-primary px-5 py-6 rounded-md">Aggiungi al carrello</Button>
                            )
                        }

                    </div>
                </div>


            </div>
        </>

    );
}
